import { init as initApm } from '@elastic/apm-rum';
import { EnvConfig } from './config/envconfig';

export const initElasticApm = (config?: EnvConfig) => {
    if (config?.Environment === 'Local') return;

    initApm({
        serviceName: 'ahudesignlite',
        serverUrl:
            'https://7a989ebebfd04f1f849e92876ed1453e.apm.eu-west-1.aws.cloud.es.io:443',
        breakdownMetrics: true,
        environment: config?.Environment,
        distributedTracingOrigins: [
            import.meta.env.BASE_URL,
            config?.websocket_url ?? '',
            config?.bff_api_url ?? ''
        ],
        centralConfig: true
    });
};
